import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'authority-labs-drag-icon',
  template: `
    <svg [attr.width]="size" fill="currentColor" viewBox="0 0 24 24">
      <path
        d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
      ></path>
      <path d="M0 0h24v24H0z" fill="none"></path>
    </svg>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DragIconComponent {
  @Input() size = '20px';
}
